<template>
  <v-container class="py-1">
    <v-row>
      <v-col class="pa-0" cols="12"><v-divider></v-divider></v-col>
      <v-col class="text-left px-0" cols="6">
        <h2>Lotes</h2>
      </v-col>
      <v-col class="text-right px-0" cols="6">
        <p style="font-size: 16px"><b>Total (R$): </b>{{ value.vl_total_lotes | formatPrice }}</p>
      </v-col>
      <v-col class="text-right px-0" style="margin-top: -1.5rem" cols="12" sm="5" md="5">
        <v-text-field
          v-model="search"
          small
          height="30px"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar"
          single-line
          outlined
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col class="text-left px-0 py-0" style="margin-top: -0.3rem" cols="auto">
        <v-checkbox
          class="pa-0 ma-0 pl-5"
          v-model="filter"
          label="Exibir lotes que já possuem notas fiscais"
          hide-details
          dense
          @change="filterList(lotes)"
          :disabled="cboxEnabled"
        ></v-checkbox>
      </v-col>
      <v-col class="px-0" cols="12">
        <v-data-table
          :headers="headers"
          :items="lotes"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          hide-default-footer
          class="lotesListTable"
          :search="search"
          :items-per-page="itemsPerPage"
          :page.sync="page"
          @page-count="pageCount = parseInt($event, 10)"
        >
          <template v-slot:item="props">
            <tr>
              <td class="text-left pa-2">
                <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      >{{ props.item.arq_nome }}</span
                    >
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                    >{{ props.item.arq_nome }}</span
                  >
                </v-tooltip>
              </td>
              <td class="text-center pa-2">{{ props.item.arq_numero_lote | formatNullValue }}</td>
              <td class="text-right pa-2">{{ props.item.arq_vl_calculado | formatPrice}}</td>
              <td class="text-center pa-2">{{ props.item.arq_nfs ? props.item.arq_nfs.join(", ") : null | formatNullValue }}</td>
              <td class="text-center pa-2">
                <v-btn small color="primary lighten-2" icon>
                  <v-switch
                    inset
                    multiple
                    v-model="lotesAssociadosList"
                    :key="props.item.id"
                    :value="props.item"
                    :input-value="props.item.is_associada"
                    @change="getLotesAssociados(lotesAssociadosList)"
                  ></v-switch>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col class="text-center py-0" cols="12">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
moment.locale("pt-BR");
export default {
    data() {
      return {
        lotesAssociadosList: null,
        search: "",
        lotes: [],
        sortBy: "is_associada",
        sortDesc: true,
        filter: false,
        headers: [
          { text: "Arquivo", value: "arq_nome", sortable: false, 'filterable': true },
          { text: "Núm. lote", align: "start", value: "arq_numero_lote", sortable: false, 'filterable': true },
          { text: "Valor (R$)", value: "arq_vl_calculado", sortable: false, 'filterable': true },
          { text: "Nota fiscal", value: "arq_nfs", sortable: false, 'filterable': true },
          { text: "Associado", value: "is_associada", sortable: false },
        ],
        page: 1,
        pageCount: 0,
        itemsPerPage: 10
      }
    },
    methods: {
      filterList() {
        if (this.filter) {
          this.lotes = this.list;
          this.sortBy = 'arq_nfs';
        }
        else {
          this.lotes = this.list.filter((item) => !item.nfs_associadas.length || item.nfs_associadas.includes(this.nfId))
          this.sortBy = 'is_associada'
        }
      }
    },
    computed: {
      cboxEnabled() {
        let hasNfAssociada = this.list.every((item) => item.nfs_associadas.length === 0);
        return hasNfAssociada;
      },
    },
    filters: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      formatDate(date) {
        return moment(date).format("L");
      },
      formatNullValue(val) {
        return val ? val : '-';
      },
    },
    watch: {
      list(val) {
        this.filter = false;
        this.search = "";
        this.lotes = val.filter((item) => !item.nfs_associadas.length || item.nfs_associadas.includes(this.nfId));
        this.lotesAssociadosList = val.filter(item => item.is_associada == 1 && item.nfs_associadas.includes(this.nfId));
      },
      lotesAssociadosList() {
        let vlTotal = this.lotesAssociadosList.reduce((total, item) => total + item.arq_vl_calculado, 0);
        this.value = { vl_total_lotes: vlTotal };
      }
    },
    props: {
      list: Array,
      value: Object,
      nfId: String,
      getLotesAssociados: Function
    }
};
</script>

<style scoped>
.v-data-table {
  max-height: 34vh;
  overflow-y: scroll;
  overflow-x: hidden;
  overscroll-behavior: contain;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th:first-child,
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td:first-child{
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th:nth-last-child(1),
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-last-child(1){
    max-width: 50px;
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th:nth-last-child(2),
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-last-child(2){
    max-width: 100px;
}

</style>